import OrganizationUnit from './OrganizationUnit/OrganizationUnit'
import useConceptConfiguration from './useConceptConfiguration'

const ConceptCalculation: React.FC<{}> = () => {
  const { getActiveConcept, conceptDataCluster, loading, updateActiveConceptUnit } = useConceptConfiguration()

  if (!loading && !getActiveConcept()) return null

  return (
    <div className="shadow-lg p-5">
      <OrganizationUnit conceptDataCluster={conceptDataCluster} concept={getActiveConcept()} update={updateActiveConceptUnit} />
    </div>
  )
}

export default ConceptCalculation
